import clsx from 'clsx';
import React from 'react';

import { newsletter_list_path } from '@routes';

import { EXPLORE_OUR_NEWSLETTERS_TEXT } from './constants';

interface NewsletterSignupConfirmationCardProps {
  className?: string;
  handleClickCapture: (clickText: string) => void;
}

const NewsletterSignupConfirmationCard = ({
  className,
  handleClickCapture,
}: NewsletterSignupConfirmationCardProps) => {
  return (
    <aside className={clsx(className, 'text-center')} data-testid="titv-rail-newsletter-explore">
      <a
        href={newsletter_list_path()}
        className="mt-32 inline-block font-suisse-intl text-button-sm text-primary-magenta underline transition-colors hover:text-primary-pink dark:text-primary-pink dark:hover:text-primary-magenta"
        onClickCapture={() => handleClickCapture(EXPLORE_OUR_NEWSLETTERS_TEXT)}
      >
        {EXPLORE_OUR_NEWSLETTERS_TEXT}
      </a>
    </aside>
  );
};

export default NewsletterSignupConfirmationCard;
